import { apiDlUrl } from '@/environment/environment';

export const apiConstants = {
  fetchGuide: 'mock-data/predictor/guide.json',
  fetchTags: 'mock-data/tags.json',
  fetchArtefacts: 'mock-data/predictor/artefacts.json',
  fetchArtefact: 'mock-data/predictor/artefact.json',
  fetchArtifactUnit: 'mock-data/predictor/artefactUnit.json',
  sdt: apiDlUrl+'appstoredemand',
  sdf: apiDlUrl+'appstoreskudemand',
  sst: apiDlUrl+'appstoreskutrend',
  sct: apiDlUrl+'appstorecattrend',
  scdf: apiDlUrl+'appstoreskudemand',
  spo: apiDlUrl+'appstoreskuorder',
  sos: apiDlUrl+'appstorepo',
  cdf: apiDlUrl+'clistorecat',
  pot: apiDlUrl+'clisavestorepo',

  sdt_mock: 'mock-data/predictor/appstoredemand_delhi_jk.json',
  sdf_mock: 'mock-data/predictor/appstoreskudemand_delhi_jk.json',
  scdf_mock: 'mock-data/predictor/appstoreskudemand_delhi_jk.json',

// sdf: 'mock-data/predictor/clistoredemand.json',
// spo: 'mock-data/predictor/clistoreskudemand.json'
// sdf: 'mock-data/predictor/clistoreallcatnew.json',
//  scdf: 'mock-data/predictor/clistorecat.json',
//  cdf: 'mock-data/predictor/clistorecat.json',
//  pot: 'mock-data/predictor/clisavestorepo.json',
//  spo: 'mock-data/predictor/clistorepo.json',
};
